import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/supplierContract', request)
}

export {get}
